import React from 'react';
import useI18next from '../../useI18next';
/**
 * Dynamically loads this library's translations. Be sure this is wrapped in a `<Suspense />` tag.
 */ const I18NextLoader = ()=>{
    useI18next();
    return null;
};
I18NextLoader.displayName = 'I18NextLoader';
export default I18NextLoader;

//# sourceMappingURL=I18NextLoader.js.map